import { useState, useEffect } from "react";
import { DashboardShell } from "@/components/layout/DashboardShell";
import { carrierNav } from "@/pages/carrier/nav";
import { ScoreBar } from "@/components/common";
import { api } from "@/lib/api";
import { Loader2, Gauge } from "lucide-react";

export default function XDScore() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/carrier/xd-score").then((r) => setD(r.data)); }, []);
  if (!d) return <DashboardShell nav={carrierNav}><div className="py-24 grid place-items-center"><Loader2 className="animate-spin text-xd-orange" size={32} /></div></DashboardShell>;

  const color = d.score >= 85 ? "#34C759" : d.score >= 60 ? "#007AFF" : "#FF5500";
  return (
    <DashboardShell nav={carrierNav} title="XD Score">
      <div className="grid gap-6 lg:grid-cols-3">
        <div className="bg-xd-paper border border-xd-border rounded-xl p-8 flex flex-col items-center justify-center text-center">
          <Gauge size={28} className="text-xd-orange mb-2" />
          <p className="text-xs uppercase tracking-[0.2em] text-xd-dim font-bold">Platform Readiness</p>
          <div className="relative my-4 w-40 h-40 grid place-items-center">
            <svg className="absolute inset-0 -rotate-90" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="44" fill="none" stroke="#2D2D2D" strokeWidth="8" />
              <circle cx="50" cy="50" r="44" fill="none" stroke={color} strokeWidth="8" strokeLinecap="round"
                strokeDasharray={`${(d.score / 100) * 276} 276`} />
            </svg>
            <div><p data-testid="xd-score-value" className="font-heading text-5xl font-black" style={{ color }}>{d.score}</p><p className="text-xs text-xd-dim">/ 100</p></div>
          </div>
          <p className="text-sm text-xd-muted">{d.score >= 85 ? "Excellent standing" : d.score >= 60 ? "Good — keep improving" : "Needs attention"}</p>
        </div>

        <div className="lg:col-span-2 bg-xd-paper border border-xd-border rounded-xl p-6 space-y-5">
          <h2 className="font-heading text-lg font-bold">Score breakdown</h2>
          {d.categories.map((c) => <ScoreBar key={c.category} label={c.category} value={c.score} recommendation={c.recommendation} />)}
        </div>
      </div>
      <p className="mt-6 rounded-lg border border-xd-border bg-xd-paper p-4 text-xs text-xd-dim">{d.disclaimer}</p>
    </DashboardShell>
  );
}
